import { createGlobalStyle } from 'styled-components';

import 'font-awesome/css/font-awesome.css';

export default createGlobalStyle`
@import url('https://fonts.googleapis.com/css?family=Poppins:300,400,500,600&display=swap');
    
  body, body.gearbox-body {
  		min-height: 100vh;
  		overflow-y: scroll;
		overflow-x: hidden;
		.btn {
			font-size: 1.6rem;
		}
		.form-control {
			font-size: 1.6rem;
		}
    nav, header, footer {
    	text-rendering: optimizeLegibility;
		font-family: 'Poppins', sans-serif;
		a, a:hover { text-decoration: none;cursor: pointer;color: inherit; }
		-webkit-font-smoothing: initial;
		*{-moz-box-sizing: border-box;box-sizing: border-box;}
		::-webkit-input-placeholder, ::-moz-placeholder, :-ms-input-placeholder{color: inherit;}
		::-moz-placeholder{opacity: 1;}
		:-webkit-autofill, :-webkit-autofill:focus {box-shadow: 0 0 0 50px white inset;}
		cite, var, address, dfn{font-style: inherit;}
		ul{padding-left: 0;}
		ol, ul, li{list-style-type: none;}
		a{text-decoration: none;cursor: pointer;color: inherit;}
		textarea{resize: none;overflow-y: auto;}
		iframe{border-style: none;}
		[disabled]{cursor: not-allowed;}
    }
    header {
    	.modal {
			font-size: 10px;
			font-family: 'Poppins', sans-serif;
			position: fixed;
			left: 0;
			top: 0;
			width: 100vw;
			height: 100vh;
			z-index: 7;
			display: -webkit-box;
			display: -webkit-flex;
			display: -ms-flexbox;
			display: flex;
			-webkit-box-pack: center;
			-webkit-justify-content: center;
			-ms-flex-pack: center;
			justify-content: center;
			-webkit-box-align: center;
			-webkit-align-items: center;
			-ms-flex-align: center;
			align-items: center
		}
		
		.modal h3 {
			margin-bottom: 0;
		}
		
		.modal a,
		.modal .modal__link {
			color: #43BCCD;
			text-decoration: none;
			cursor: pointer;
			background-color: transparent
		}
		
		.modal--close {
			pointer-events: none
		}
		
		.modal--close .modal__bg {
			-webkit-animation: modalBgClose 0.4s forwards;
			animation: modalBgClose 0.4s forwards
		}
		
		.modal--close .modal__box {
			-webkit-animation: modalBoxClose 0.2s forwards;
			animation: modalBoxClose 0.2s forwards
		}
		
		.modal__bg {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 150vh;
			-webkit-animation: modalBgOpen 0.4s forwards;
			animation: modalBgOpen 0.4s forwards
		}
		
		.modal__box {
			-webkit-animation: modalBoxOpen 0.4s forwards;
			animation: modalBoxOpen 0.4s forwards;
			-webkit-transition: height 0.3s;
			transition: height 0.3s;
			max-width: 664px;
			width: 100%;
			background-color: #FFFFFF;
			color: #4D4C59;
			border-radius: 4px;
			position: relative;
			z-index: 7;
			padding-top: 60px;
			max-height: 90vh;
			display: -webkit-box;
			display: -webkit-flex;
			display: -ms-flexbox;
			display: flex;
			-webkit-box-orient: vertical;
			-webkit-box-direction: normal;
			-webkit-flex-direction: column;
			-ms-flex-direction: column;
			flex-direction: column
		}
		
		.modal__box--large {
			max-width: 1140px
		}
		
		.modal__box--large .modal__channel-switch .inputswitch {
			width: 100%;
			pointer-events: all
		}
		
		.modal__close,
		.modal__prev {
			position: absolute;
			z-index: 1;
			top: 32px;
			width: 16px;
			height: 16px;
			background-size: cover;
			cursor: pointer
		}
		
		.modal__close:hover,
		.modal__prev:hover {
			opacity: 0.8
		}
		
		.modal__close {
			right: 32px
		}
		
		.modal__prev {
			left: 32px
		}
		
		.modal__icon {
			width: 64px;
			height: 64px;
			margin: 0 auto 16px;
			background-size: cover;
			fill: #4D4C59
		}
		
		.modal__icon__container {
			display: -webkit-box;
			display: -webkit-flex;
			display: -ms-flexbox;
			display: flex
		}
		
		.modal__header .modal__icon {
			fill: #F3123C;
			width: 44px;
			height: 44px;
			margin-bottom: 24px
		}
		
		.modal__wrap {
			padding: 32px 48px 32px;
			overflow-y: auto;
			overflow-x: hidden;
			display: -webkit-box;
			display: -webkit-flex;
			display: -ms-flexbox;
			display: flex;
			-webkit-box-orient: vertical;
			-webkit-box-direction: normal;
			-webkit-flex-direction: column;
			-ms-flex-direction: column;
			flex-direction: column;
			overflow: hidden
		}
		
		.modal__wrap-hide {
			display: none
		}
		
		.modal__wrap--shadow {
			position: relative
		}
		
		.modal__wrap--shadow:after {
			position: absolute;
			bottom: 32px;
			left: 48px;
			right: 64px;
			height: 70px;
			background-image: -webkit-gradient(linear, left bottom, left top, color-stop(30%, #fff), to(transparent));
			background-image: linear-gradient(to top, #fff 30%, transparent 100%);
			content: '';
			pointer-events: none
		}
		
		.modal__wrap--shadow .modal__content {
			padding-bottom: 42px
		}
		
		.modal__bigtitle {
			font-size: 2.4em;
			line-height: 1.4em;
			text-align: center;
			font-weight: 600;
			margin-bottom: 16px
		}
		
		.modal__list-title {
			color: #4D4C59;
			font-size: 1.6em;
			font-weight: 600;
			padding: 32px 0 12px 16px
		}
		
		.modal__list-row {
			border-top: 1px solid #ECEDF2;
			padding: 8px 16px;
			font-size: 1.4em;
			height: 56px;
			-webkit-transition: padding 0.3s, height 0.3s;
			transition: padding 0.3s, height 0.3s;
			display: -webkit-box;
			display: -webkit-flex;
			display: -ms-flexbox;
			display: flex;
			-webkit-box-align: center;
			-webkit-align-items: center;
			-ms-flex-align: center;
			align-items: center;
			-webkit-box-pack: justify;
			-webkit-justify-content: space-between;
			-ms-flex-pack: justify;
			justify-content: space-between
		}
		
		.modal__list-row:last-child {
			border-bottom: 1px solid #ECEDF2
		}
		
		.modal__list-row--hide {
			padding: 0px;
			height: 0px;
			font-size: 0px;
			border-top-style: none
		}
		
		.modal__list-row--hide .modal__list-right {
			display: none
		}
		
		.modal__list-row--hide .svg {
			display: none
		}
		
		.modal__list-name {
			color: #43bccd
		}
		
		.modal__list-map {
			display: -webkit-box;
			display: -webkit-flex;
			display: -ms-flexbox;
			display: flex;
			-webkit-box-align: center;
			-webkit-align-items: center;
			-ms-flex-align: center;
			align-items: center
		}
		
		.modal__list-map .svg {
			height: 16px;
			margin-right: 8px;
			fill: #4D4C59
		}
		
		.modal__list--group .modal__list-row .svg {
			width: 16px;
			height: 16px;
			fill: #4D4C59;
			margin-right: 8px
		}
		
		.modal__content {
			-webkit-box-flex: 1;
			-webkit-flex: 1;
			-ms-flex: 1;
			flex: 1;
			overflow-y: scroll;
			padding-right: 8px
		}
		
		.modal__content::-webkit-scrollbar {
			background: transparent;
			width: 8px;
			-webkit-transition: width 0.3s;
			transition: width 0.3s
		}
		
		.modal__content::-webkit-scrollbar-track {
			border-radius: 16px
		}
		
		.modal__content::-webkit-scrollbar-thumb {
			background-color: #8B8C99;
			border-radius: 16px;
			border: 2px solid #FFFFFF
		}
		
		.modal__content:hover {
			padding-right: 0px
		}
		
		.modal__content:hover::-webkit-scrollbar {
			width: 16px
		}
		
		.modal__content:hover::-webkit-scrollbar-track {
			background-color: #F3F5F8
		}
		
		.modal__content:hover::-webkit-scrollbar-thumb {
			border: 2px solid #F3F5F8
		}
		
		.modal__content--noscroll:hover {
			padding-right: 16px
		}
		
		.modal__content--noscroll:hover::-webkit-scrollbar {
			width: 0px
		}
		
		.modal__content--noscroll:hover::-webkit-scrollbar-track {
			background-color: transparent
		}
		
		.modal__content--noscroll:hover::-webkit-scrollbar-thumb {
			border: 2px solid transparent
		}
		
		.modal__error {
			text-align: center
		}
		
		.modal__error-text {
			display: block;
			font-size: 1.6em
		}
		
		.modal__error-icon {
			width: 100px;
			height: 100px;
			fill: #4D4C59
		}
		
		.modal__zindex {
			z-index: 10
		}
		
		.modal__back {
			font-weight: 500;
			font-size: 14px
		}
		
		.modal__back:before {
			content: '';
			display: inline-block;
			width: 8px;
			height: 8px;
			border-left: 2px solid #43BCCD;
			border-bottom: 2px solid #43BCCD;
			-webkit-transform: rotate(45deg) translate(2px, -3px);
			-ms-transform: rotate(45deg) translate(2px, -3px);
			transform: rotate(45deg) translate(2px, -3px);
			margin-right: 8px
		}
		
		.modal__buttons {
			padding: 16px 48px 32px
		}
		
		.modal .btn--red {
			background-color: #F3123C;
			color: #FFFFFF
		}
		
		@media (max-width: 768px) {
			.modal__box {
				z-index: 7;
				padding: 16px;
				width: 90%;
				max-height: 90vh
			}
			.modal__content {
				max-height: 80vh;
				padding: 16px
			}
			.modal__bigtitle {
				line-height: 1.2em
			}
			.modal__header .modal__icon {
				margin-bottom: 8px
			}
		}
		
		_:-ms-fullscreen,
		:root .modal__textplain {
			min-height: 470px
		}
    }
    footer {
		color: #8b8c99;
    }
    -webkit-font-smoothing: antialiased;
  }
  
  html {
  	font-size: 10px;
  }
  
  html, body, #root {
    height: 100%;
    
  }
  
  .box {
    border-radius: 4px;
    padding: 25px;
    background-color: #FFFFFF;
    box-shadow: 0 3px 4px rgba(0,0,0,.2);
    
      .title {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        
        svg {
          color: #F3463C;
          font-size: 16px;
        }
        
        h4 {
          font-family: Poppins-Medium,Heltica,Arial,sans-serif;
          font-size: 14px;
          display: inline-block;
          margin-left: 10px;
          margin-bottom: 0;
        }
        
        * {
          margin: 0;
          padding: 0;
        }
      }
  }
  
  .content-1200 {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .container-gearbox {
    max-width: 1600px;
    padding: 0 27px 27px;
  }
  
  .hide {
    opacity: 0;
  }
  
  .show {
    opacity: 1;
  }

  .list-style-none {
    list-style: none;
  }
  
  .custom-tooltip {
    font-size: 14px;
    padding: 10px;
    background-color: #FFFFFF;
    border: 1px solid #555555;
    color: #555555;
    
    .label-clicks {
      color: #333333;
    
      &.element-google {
      	color: #f24847;
      }

      &.element-instagram {
      	color: #BE3086;
      }
      
      &.element-facebook,
      &.element-facebook_instagram {
      	color: #1877F2;
      }
    }
    
    .label-impressions {
      color: #6F6F70;
      
      &.element-google {
      	color: #6F6F70;
      }

      &.element-instagram {
      	color: #6944C2;
      }
      
      &.element-facebook,
      &.element-facebook_instagram {
      	color: #6F6F70;
      }
    }
  }
`;
